/* eslint-disable default-param-last */
import { ADD_FLIGHT, DELETE_FLIGHT } from './actionTypes';

const initialState = {
  flights: [],
};

const flightBookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_FLIGHT:
      //   console.log(action.payload);
      return {
        ...state,
        flights: [
          ...state.flights,
          {
            id: Date.now(),
            ...action.payload,
          },
        ],
      };

    case DELETE_FLIGHT:
      return {
        ...state,
        flights: state.flights.filter(flight => flight.id !== action.payload),
      };

    default:
      return state;
  }
};

export default flightBookingReducer;
